<template>
    <div style="display:flex;width:100%">
    <multiselect v-if="!!schema && schema.values && schema.values.length > 0 && (currentValue.length > 0 || selectOptions.preSelectFirst)"
            :id="selectOptions.id"
            :options="schema.values"
            v-model="currentValue"
            :multiple="selectOptions.multiple"
            :track-by="selectOptions.trackBy || null"
            :label="selectOptions.label || null"
            :searchable="selectOptions.searchable"
            :clear-on-select="selectOptions.clearOnSelect"
            :preselect-first="selectOptions.preSelectFirst"
            :hide-selected="selectOptions.hideSelected"
            :placeholder="schema.placeholder"
            :allow-empty="selectOptions.allowEmpty"
            :reset-after="selectOptions.resetAfter"
            :close-on-select="selectOptions.closeOnSelect"
            :custom-label="customLabel"
            :taggable="selectOptions.taggable"
            :tag-placeholder="selectOptions.tagPlaceholder"
            :max="schema.max || null"
            :options-limit="selectOptions.optionsLimit"
            :group-values="selectOptions.groupValues"
            :group-label="selectOptions.groupLabel"
            :block-keys="selectOptions.blockKeys"
            :internal-search="selectOptions.internalSearch"
            :select-label="selectOptions.selectLabel"
            :selected-label="selectOptions.selectedLabel"
            :deselect-label="selectOptions.deselectLabel"
            :show-labels="selectOptions.showLabels"
            :limit="selectOptions.limit"
            :limit-text="selectOptions.limitText"
            :loading="isLoading"
            :disabled="disabled"
            :max-height="selectOptions.maxHeight"
            :show-pointer="selectOptions.showPointer"
            @select="selectOptions.onSelect"
            @remove="onRemove"
            @open="onOpen"
            @close="onClose"
            :option-height="selectOptions.optionHeight"
            :open-direction="selectOptions.openDirection"
    >
    </multiselect>
      <button v-if="selectOptions.showAddNewButton && typeof $parent.$parent.headerData.customer_id !== 'undefined' && $parent.$parent.headerData.customer_id !== null" @click="popup()" class="btn btn-secondary ml-1">{{ '+' | translate }}</button>
      <b-modal @ok="saveNewContact" v-model="showNewContactPopup" :title="$t('Add new contact for customer') +  ''">
        <form>
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <p class="mb-2">{{'First name' | translate }}</p>
                <input required class="form-control w-100" name="first_name" v-model="newContact.first_name">
                </input>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="form-group">
                <p class="mb-2">{{'Last name' | translate }}</p>
                <input required class="form-control w-100" name="last_name" v-model="newContact.last_name">
                </input>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="form-group">
                <p class="mb-2">{{'Phone' | translate }}</p>
                <input class="form-control w-100" name="phone" :required="(typeof selectOptions.addParams !== 'undefined' && typeof selectOptions.addParams.showFlags !== 'undefined' && typeof selectOptions.addParams.showFlags.show_in_picklist !== 'undefined')" type="phone" v-model="newContact.phone">
                </input>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="form-group">
                <p class="mb-2">{{'E-mail' | translate }}</p>
                <input class="form-control w-100" name="email" type="email" v-model="newContact.email"></input>
              </div>
            </div>
          </div>
        </form>
      </b-modal>
    </div>
</template>
<script>
  import {abstractField} from 'vue-form-generator'
  export default {
    mixins: [abstractField],
    data () {
      return {
        showNewContactPopup: false,
        isLoading: false,
        currentCustomerId: null,
        defaultNewContact: {
          email: null,
          first_name: null,
          last_name: null,
          phone: null,
          show_in_workorder: 0,
          show_in_picklist: 0
        },
        newContact: {},
        options: []
      }
    },
    computed: {
      currentValue: {
        get () {
          return this.schema.values.filter(
            option => parseInt(this.schema.initialValues) === parseInt(option.id)
          )
        },
        set (newSelectedOptions) {
          if (newSelectedOptions instanceof Array) {
            this.value = newSelectedOptions.map(option => option.id)
          } else {
            this.value = newSelectedOptions.id
          }
        }
      },
      selectOptions () {
        return this.schema.selectOptions || {}
      },
      addTag (newTag, id) {
        let onNewTag = this.selectOptions.onNewTag
        if (typeof (onNewTag) === 'function') {
          onNewTag(newTag, id, this.options, this.value)
        }
      },
      customLabel () {
        if (typeof this.schema.selectOptions !== 'undefined' && typeof this.schema.selectOptions.customLabel !== 'undefined' && typeof this.schema.selectOptions.customLabel === 'function') {
          return this.schema.selectOptions.customLabel
        } else {
          // this will let the multiselect library use the default behavior if customLabel is not specified
          return undefined
        }
      }
    },
    methods: {
      validatePostData: function (d) {
        var errorText = '- '
        if (typeof d['first_name'] === 'undefined' || d['first_name'] === null || d['first_name'].length === 0) {
          errorText += 'First name - '
        }
        if (typeof d['last_name'] === 'undefined' || d['last_name'] === null || d['last_name'].length === 0) {
          errorText += 'Last name - '
        }
        if (errorText !== '- ') {
          this.$notify({
            group: 'full',
            text: this.$t('Please fill in the following fields: ' + errorText)
          })
          return false
        } else {
          return true
        }
      },
      saveNewContact (bvModalEvt) {
        var vm = this
        if (!this.validatePostData(this.newContact)) {
          bvModalEvt.preventDefault()
          return false
        }
        if (typeof this.selectOptions.addParams !== 'undefined' && typeof this.selectOptions.addParams.showFlags !== 'undefined') {
          Object.keys(this.selectOptions.addParams.showFlags).forEach((key) => {
            vm.newContact[key] = vm.selectOptions.addParams.showFlags[key]
          })
        }
        this.$http.post('customercontact/' + this.currentCustomerId, {customercontact: this.newContact}).then(function (res) {
          if (res.status === 200) {
            vm.$notify({
              group: 'full',
              text: res.data.msg
            })
            vm.$parent.$parent.refreshCustomerContact(this.currentCustomerId)
            vm.resetContact()
          } else {
            vm.$notify({
              group: 'full',
              text: res.data.msg
            })
          }
        })
      },
      resetContact () {
        this.newContact = Object.assign({}, this.defaultNewContact)
      },
      popup () {
        this.resetContact()
        console.log(this.$parent.$parent.headerData.customer_id)
        this.currentCustomerId = this.$parent.$parent.headerData.customer_id
        this.showNewContactPopup = !this.showNewContactPopup
      },
      updateSelected (value) {
        this.value = value
      },
      onSearchChange (searchQuery, id) {
        let onSearch = this.selectOptions.onSearch
        if (typeof (onSearch) === 'function' && searchQuery) {
          this.isLoading = true
          onSearch(searchQuery, id, this.options).then(response => {
            this.options = response
            this.isLoading = false
          })
        }
      },
      onSelect (/* selectedOption, id */) {
        // console.log("onSelect", selectedOption, id);
      },
      onRemove (/* removedOption, id */) {
        // console.log("onRemove", removedOption, id);
      },
      onOpen (/* id */) {
        // console.log("onOpen", id);
      },
      onClose (/* value, id */) {
        // console.log("onClose", value, id);
      }
    },
    watch: {
      options: (newVal) => {
        // console.log(newVal)
      }
    },
    created () {
      // Check if the component is loaded globally
      if (!this.$root.$options.components['multiselect']) {
        console.error('\'vue-multiselect\' is missing. Please download from https://github.com/monterail/vue-multiselect and register the component globally!')
      }
      let values = this.schema.values
      if (typeof (values) === 'function') {
        this.options = values.apply(this, [this.model, this.schema])
      } else {
        this.options = values
      }
    }
  }
</script>


// WEBPACK FOOTER //
// VfgMultiDropDown.vue?78bc29a5